/**
 * Плоский индекс меню филиала: id товара ИЛИ варианта группы → узел каталога.
 *
 * Заказ и избранное ссылаются на конкретный вариант, а показывать нужно
 * родительский узел — карточку каталога (бейджи, стоп-лист, открытие модалки).
 *
 * Единственная реализация обхода «категории → узлы → варианты групп»: её
 * используют избранное (институт-стор) и «вы заказывали» — не копируй обход
 * в новые потребители dish-groups.
 */
export interface MenuNodeIndex {
  /** id товара или варианта группы → узел меню (родитель для вариантов) */
  byProductId: Map<string, any>
  /** id узла каталога → узел */
  byNodeId: Map<string, any>
}

export function buildMenuNodeIndex(
  categories: ReadonlyArray<{ products?: unknown[] } | null | undefined> | null | undefined,
): MenuNodeIndex {
  const byProductId = new Map<string, any>()
  const byNodeId = new Map<string, any>()

  for (const category of categories || []) {
    for (const node of (category?.products || []) as any[]) {
      if (node?.id == null) continue
      byNodeId.set(String(node.id), node)
      if (node.type === 'group' && Array.isArray(node.variants)) {
        for (const variant of node.variants) {
          if (variant?.id != null) byProductId.set(String(variant.id), node)
        }
      } else {
        byProductId.set(String(node.id), node)
      }
    }
  }

  return { byProductId, byNodeId }
}
